<div class="card-container">
  <div class="title-wrapper">
    <h3>Review and confirm</h3>
  </div>
  <div>
    <room-info-preview
      [roomName]="roomName"
      [playlistId]="playlistId"
      [theme]="theme"
      [roomSizeInfo]="roomSizeInfo"
    ></room-info-preview>
  </div>
  @if (itemEditor) {
    <div class="info-row">
      <mat-icon svgIcon="INFO_OUTLINE_NAVY"></mat-icon>
      <span>
        Add even more to your room like <b>room items</b> and <b>files</b> or <b>web links</b>. Create and Decorate to
        do more!
      </span>
    </div>
  }
  <div class="footer-wrapper">
    <button data-testid="secondaryButton" class="secondary-button" (click)="back()">Back</button>
    @if (itemEditor) {
      <button data-testid="decorateButton" class="secondary-button" (click)="createAndDecorate()">
        Create & Decorate
      </button>
    }
    <button data-testid="primaryButton" class="primary-button" (click)="nextStep()">
      {{ isCreateFlow ? 'Create' : 'Save' }}
    </button>
  </div>
</div>
